module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABWElEQVQ4T62VTSsGYRSGr1u+Vr5Xkh+hpFjYUDZ+gYWNbBRLyu61s6IsiJT/YCFRSnaKLaWsWJBE2XF06nnrNc0z8wxmN/Occ825zzlzjwDMbBbYBtr9PvGalHSSFyszGwTugOZEWD1sWdJ6DLoAbGUOzQUUvOQKmJL0HIMuARsNh/vAKvARg0p6K1Ll8heBzRDk1fVIek1thZn1Aq2SHus5Wegn0C3pvQL0GBgGRiTdel4W+gV0VYReAKPAjcM99z+gZ8B4UHYoaboQamZNQA0Yi7TDZzAEdDac18qg88BOan9jg/rRUzObA3b/G+ry18Ig8tjV5adUaGbVBpUILV2p3yz/kS9+0fJ7j/okvaRUGWzTP9M2SQ+N088aygGw8ldDydvFMuu7Dtb3FLO+fuAeaEmVHOLiJh36MgPsVfydTEg6za20/tDMBlwS0FHi+p5yKek8puwb7Ba7CtjAUNMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/exitIcon.png
// module id = 1koE
// module chunks = 2